var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImageTo3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2101 4.5463C12.0768 4.48457 11.9232 4.48457 11.7899 4.5463L6.78987 6.86209C6.61312 6.94395 6.5 7.12101 6.5 7.31579V11.2228L2.735 13.5759C2.58492 13.6697 2.49561 13.8359 2.50017 14.0128C2.50472 14.1897 2.60247 14.3511 2.75718 14.437L11.7572 19.437C11.9147 19.5245 12.107 19.5205 12.2607 19.4266L21.2607 13.9266C21.4158 13.8318 21.5073 13.6603 21.4995 13.4787C21.4918 13.2971 21.3862 13.134 21.2236 13.0527L17.5 11.1909V7.31579C17.5 7.12101 17.3869 6.94395 17.2101 6.86209L12.2101 4.5463ZM17.5 12.309V13.1053C17.5 13.2837 17.4049 13.4486 17.2505 13.538L12.2505 16.4327C12.0956 16.5224 11.9044 16.5224 11.7495 16.4327L6.74948 13.538C6.59507 13.4486 6.5 13.2837 6.5 13.1053V12.4021L3.98395 13.9746L11.988 18.4213L19.9695 13.5437L17.5 12.309ZM11.5 10.1331L7.5 8.12608V12.817L11.5 15.1328V10.1331ZM16.5 12.817L12.5 15.1328V10.1331L16.5 8.12608V12.817ZM15.8492 7.33381L12 9.26515L8.15081 7.33381L12 5.55103L15.8492 7.33381Z",
    fill: "#47495F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageTo3D);
export default __webpack_public_path__ + "static/media/icon-imageTo3D.8ca8061101fd322134aae3ad0339d2db.svg";
export { ForwardRef as ReactComponent };